import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import cookies from 'js-cookie';
import AppRouter from '../../routes/router';
import Header from '../../components/header/header';
import Footer from '../../components/footer/footer';
import Spin from '../../components/loading';
import HorizontalMenu from '../../components/HorizontalMenu';
import { getMeInfo } from '../../redux/auth/actions';
import * as notificationActions from '../../redux/notifications/actions';
import * as reservationActions from '../../redux/reservations/actions';
import { notificationHelper } from '../../utils';
import ENUMS from '../../enums';
import AlertAndConfirmation from '../../utils/AlertAndConfirmation';
import socketIoClient from 'socket.io-client';


class Layout extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
    };
  }

  componentDidMount() {
    this.props.getMeInfo().then(_ => {
      this.setState(() => ({
        loading: false,
      }));
    });

    const authToken = cookies.get('auth-token');
    if (authToken) {
      import('../../utils/SocketService').then(res => {
        const socket = res.default;
        socket.connect(ASSET_ENDPOINT_WEBSOCKET);
        socket.on('connect', _ => {
          console.log('socket io connected');
        });
        socket.on('disconnect', _ => {
          console.log('socket io was disconnected');
        });
        socket.on('error', err => {
          console.error('error in connecting to socket io server', err);
        });
        socket.on(ENUMS.SOCKET_IO_EVENTS.values.NEW_RESERVE_SUBMITTED, data => {
          console.log(ENUMS.SOCKET_IO_EVENTS.values.NEW_RESERVE_SUBMITTED);
          this.props.updateSocketReserve(data);
          const message = locales(
            'messages.a.new.reserve.request.was.submitted',
            { trackingNumber: data.trackingNumber },
          );
          this.props.setNewReserveSubmittedNotification(message);
          notificationHelper.notifyUser(message);
        });
        socket.on(
          ENUMS.SOCKET_IO_EVENTS.values.RESERVE_REQUESTS_AUTOMATICALLY_APPROVED,
          data => {
            console.log(
              ENUMS.SOCKET_IO_EVENTS.values
                .RESERVE_REQUESTS_AUTOMATICALLY_APPROVED,
              data,
            );
            this.props.updateSocketReserve(data);
            const message = locales(
              'messages.some.reserves.automatically.approved',
              {
                reservesCount: data.reservesIds.length,
              },
            );
            this.props.setReserveRequestsAutomaticallyApprovedNotification({
              message,
              ...data,
            });
            notificationHelper.notifyUser(message);
          },
        );
        socket.on(ENUMS.SOCKET_IO_EVENTS.values.RESERVE_WAS_CANCELLED, data => {
          console.log(
            ENUMS.SOCKET_IO_EVENTS.values.RESERVE_WAS_CANCELLED,
            data,
          );
          this.props.updateSocketReserve(data);
          const message = locales('messages.reserve.was.cancelled.by.user', {
            date: data.reserveDate,
            client: data.clientFullName,
          });
          this.props.setReserveRequestsAutomaticallyApprovedNotification({
            message,
            ...data,
          });
          notificationHelper.notifyUser(message);
        });

        socket.on(ENUMS.SOCKET_IO_EVENTS.values.NEW_PRINT_REQUEST_FROM_TABLET, data => {
          console.log(
            ENUMS.SOCKET_IO_EVENTS.values.NEW_PRINT_REQUEST_FROM_TABLET,
            data,
          );
          // this.props.printRequestTablet(data);
          if(data.type === "FACTOR") {
            const payload = { payload: data.payload };
            console.log("socketFactor data" , payload)
            const socketFactor = socketIoClient(
              'http://localhost:8181/factor?token=abc123',
              {
                transports: ['polling', 'websocket'],
              },
            );
        
            socketFactor.on('connect', function () {
              console.log('socketFactor io connected');
            });
            socketFactor.on('disconnect', function () {
              console.log('socketFactor io was disconnected');
            });
            socketFactor.on('reconnect_attempt', attempts => {
              console.log('socketFactor Try to reconnect at ' + attempts + ' attempt(s).');
            });
            socketFactor.emit('factor', data);
            socketFactor.on('factor', function (data) {
              socketFactor.close();
              console.log('socketFactor Received message', data);
              AlertAndConfirmation({
                type: 'error',
                title: data,
              });
            });
         
          }
           else if (data.type === "INVOICE") {
            const payload = { payload: data.payload };
            console.log("socketInvoice data" , payload)
            const socketInvoice = socketIoClient(
              'http://localhost:8181/invoice?token=abc123',
              {
                transports: ['polling', 'websocket'],
              },
            );
        
            socketInvoice.on('connect', _ => {
              console.log('socketInvoice io connected');
            });
            socketInvoice.on('disconnect', _ => {
              console.log('socketInvoice io was disconnected');
            });
            socketInvoice.on('reconnect_attempt', attempts => {
              console.log('socketInvoice Try to reconnect at ' + attempts + ' attempt(s).');
            });
        
            socketInvoice.emit('invoice', data);
        
            socketInvoice.on('invoice', data => {
              console.log('socketInvoice Received message', data);
              AlertAndConfirmation({
                type: 'error',
                title: data,
              });
            });
    
           }

        });
      });
    }
  }

  render() {
    if (this.state.loading) {
      return <Spin spinning={this.state.loading}></Spin>;
    }

    return (
      <Fragment>
        <Header {...this.props} />

        <HorizontalMenu />

        <div className='app-content container'>
          <AppRouter />
        </div>

        <Footer {...this.props} />
      </Fragment>
    );
  }
}

const mapStateToProps = state => {
  const meInfo = state.authReducer.meInfo;

  return {
    meInfo,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getMeInfo: () => dispatch(getMeInfo()),
    updateSocketReserve: data =>
      dispatch(notificationActions.updateSocketReserve(data)),
    setNewReserveSubmittedNotification: message =>
      dispatch(notificationActions.setNewReserveSubmittedNotification(message)),
    setReserveRequestsAutomaticallyApprovedNotification: data =>
      dispatch(
        notificationActions.setReserveRequestsAutomaticallyApprovedNotification(
          data,
        ),
      ),
    getReservesRequestsList: query =>
      dispatch(reservationActions.getReservesRequestsList(query)),
      printRequestTablet: data =>
      dispatch(notificationActions.printRequestTablet(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Layout);
